import { createRouter, createWebHistory } from 'vue-router'
import {useAuthStore} from "@/stores/auth.store";
const PageNotFound = () => import("@/views/PageNotFound");

import AuthRoutes from '@/router/authRoutes'
import UserRoutes from '@/router/userRoutes'
import AdminRoutes from '@/router/adminRoutes'
import GuestRoutes from '@/router/guestRoutes'
import AuthHelper from "@/helpsers/auth.helper";
import {Role} from "@/helpsers/role.helper";
import {event} from "vue-gtag";

let allRoutes = [];
allRoutes = allRoutes.concat(
    AuthRoutes,
    UserRoutes,
    AdminRoutes,
    GuestRoutes,
    [
      { path: '/not-found', component: PageNotFound },
      { path: '/:pathMatch(.*)*', component: PageNotFound },
    ]
)

const routes = allRoutes;

const router = createRouter({
  routes,
  history: createWebHistory()
})

router.beforeEach(async (to) => {
  const { authorize, globalAccess } = to.meta;
  const auth = useAuthStore();

  if (authorize && to.name !== 'logout' && auth.user)
   await AuthHelper.verificationToken();

  if (to.path === '/') {
    if (authorize && auth.user) {
      if (auth.user.role === Role.Admin) {
        auth.returnUrl = '/admin'
        return '/admin';
      } else {
        auth.returnUrl = '/my-profile'
        return '/my-profile';
      }
    } else {
      return '/my-profile';
    }
  }

  if (auth.user && authorize && !authorize.includes(auth.user.role) && !auth.user.needToChooseRole) {
    if (auth.user.role === Role.Admin) {
      auth.returnUrl = '/admin'
      return '/admin';
    } else {
      auth.returnUrl = '/my-profile'
      return '/my-profile';
    }
  }

  if (authorize && !auth.user) {
    auth.returnUrl = to.fullPath;
    return '/login';
  } else if (!!auth.user && !authorize && to.name !== 'logout' && !globalAccess) {
      //Uzytkownik jest zalogowany i jest na stronie z publicPages
      auth.returnUrl = '/';
      return '/';

  }

  if(!!auth.user && auth.user.needToChooseRole && to.path !== '/accept-of-terms' && to.path !== '/logout') {
    return '/accept-of-terms';
  }

  if(to.path === '/accept-of-terms' && !auth.user) {
    return '/login';
  }

  let pageTitle = 'EWOODS';
  document.title = to.meta?.title ? ( to.meta?.title + ' | ' + pageTitle) : pageTitle;

  let gaData = {
    url: to.fullPath,
    title: to.meta?.title,
    params: to.params,
  };
  if (auth.user) {
    gaData.user = auth.user.id;
  }
  event(to.name, gaData)
});

export default router
